/** @format */

import {AccountsCompanyMediaplanType} from 'graphql/generated/types';

import {MediaplanDescription} from '../types';
import {MEDIAPLAN_RECORDS} from '../constants';

const getMediaplanDescription = (
  mediaplanType: AccountsCompanyMediaplanType,
): MediaplanDescription => {
  return MEDIAPLAN_RECORDS[mediaplanType];
};

export {getMediaplanDescription};
